customElements.get("pop-menu") || customElements.define("pop-menu", class extends HTMLElement {
    constructor() {
        super();
        this.isInitialized = false;
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    }

    connectedCallback() {
        if (this.isInitialized) return;

        this.elements = {
            button: this.querySelector("button"),
            panel: this.querySelector(".disclosure__list-wrapper")
        };

        this.elements.button.addEventListener("click", this.openSelector.bind(this));
        this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));

        this.querySelectorAll("a").forEach(item =>
            item.addEventListener("click", this.onItemClick.bind(this))
        );

        this.isInitialized = true;
    }

    hide() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
    }

    onContainerKeyUp(event) {
        if (event.code.toUpperCase() === "ESCAPE" && this.elements.button.getAttribute("aria-expanded") !== "false") {
            this.hide();
            event.stopPropagation();
            this.elements.button.focus();
        }
    }

    onItemClick(event) {
        // currently empty
    }

    openSelector(event) {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        const expanded = this.elements.button.getAttribute("aria-expanded") === "false";
        this.elements.button.setAttribute("aria-expanded", expanded.toString());
    }

    closeSelector(event) {
        const isChild = this.elements.panel.contains(event.target) || this.elements.button.contains(event.target);
        if (!event.relatedTarget || !isChild) {
            this.hide();
        }
    }
});
